import { useMemo } from 'react';
import { atom, useAtomValue } from 'jotai';

import { runningQuestionCardAiActionAtom } from '../stores/questionCardAi.atoms';

/**
 * 이 카드가 지금 도는 AI 작업의 원본인가 — 원본 카드의 헤더 복제·삭제를 잠그는 데 쓴다(핸드오프 #7).
 * 다른 카드의 ⚡ 는 running 여부(useQuestionCardAiActions.isLocked)로 따로 잠긴다.
 * 파생 atom 이라 원본이 바뀔 때만 해당 카드가 리렌더된다.
 */
export const useIsQuestionCardAiTarget = (quizId: string): boolean => {
  const isTargetAtom = useMemo(
    () => atom(get => get(runningQuestionCardAiActionAtom)?.quizId === quizId),
    [quizId],
  );
  return useAtomValue(isTargetAtom);
};
